import { providerApi } from '@/api/ProviderApi'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { useMemo } from 'react'
import type { UpcomingPatientAppointment } from '../types/ProviderApi'

const useFetchUpcomingAppointment = () => {
	const { data = null, isLoading } = useQuery({
		queryKey: ['upcoming-appointment'],
		queryFn: () => providerApi.fetchUpcomingAppointment(),
		select: (data) => {
			if (!data || !data.appointmentId) {
				return {} as UpcomingPatientAppointment
			}

			const startDate = format(data.startTimeLocal, 'MMM do')
			const startTime = format(data.startTimeLocal, 'h:mm a')

			data.startTimeFormatted = `${startDate} at ${startTime}`

			return data
		},
	})

	const hasUpcomingAppointment = useMemo(() => data?.appointmentId !== undefined, [data])

	return {
		isLoading,
		appointment: data,
		hasUpcomingAppointment,
	}
}

export { useFetchUpcomingAppointment }
